import React from 'react';
import { createUseStyles } from 'react-jss';
import Background from '../../Assets/images/bg.webp';

function PageHeader({ pageTitle }) {
  const useStyles = createUseStyles({
    container: {
      height: "100%",
      width: "100%",
    },
    landingContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: "75vh",
      backgroundImage: `url(${Background})`,
      backgroundSize: "cover",
      backgroundColor: "rgb(48, 37, 32, 0.5)",
      backgroundBlendMode: "darken",
    },
    pageTitleContainer: {
      width: "70%",
      maxWidth: 800,
      margin: "auto",
      textAlign: "center",
    },
    pageTitle: {
      margin: 5,
      font: { size: 70 },
      color: "white",
    },
    sectionUnderline: {
      borderBottom: "4px solid green",
      width: 150,
      margin: "auto",
    },
    '@media (max-width: 500px)': {
      pageTitle: {
        font: { size: 35 },
      },
    },
  });
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={styles.landingContainer}>
        <div className={styles.pageTitleContainer}>
          <h1 className={styles.pageTitle}>{pageTitle}</h1>
          <div className={styles.sectionUnderline} />
        </div>
      </div>
    </div>
  );
}

export default PageHeader;
